var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mobileNavActive)?_c('b-icon-x',{staticStyle:{"width":"50px","height":"50px"},on:{"click":_vm.toggleMobileNav}}):_c('b-icon-list',{staticStyle:{"width":"50px","height":"50px"},on:{"click":_vm.toggleMobileNav}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }